    /**
     * SAL1030_R01 - 품목별 수주 현황 조회
     * 검색 섹션 컴포넌트
     */

    import { ChangeEvent, useState, useEffect } from "react";
    import { useSAL1030_R01Store, defaultSAL1030_R01Filter } from "./Store_SAL1030_R01";
    import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
    import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
    import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
    import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
    import useUiuxStore from "src/store/useUiuxStore";
    import { useCommonCodeStore } from "src/store/useCommonCodeStore";
    import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
    import { InfoCodeSearchFieldConfig } from "src/types/info-form";
    import { searchCustomer } from "src/apis/customerApi";
    import { CompanyDto } from "src/dtos/company/companyDto";
    import { getEmployeeList } from "src/apis/employeeApi";
    import { searchDateRangeFormString, searchLabelStyle } from "src/components/common/common";

    export const SearchSection_SAL1030_R01 = () => {
    const { SAL1030_R01Filter, setSAL1030_R01Filter } = useSAL1030_R01Store();
    const { setCodeSearchModalProps } = useUiuxStore();
    const { compCdList } = useCommonCodeStore();
    
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

    const custInfoHandleFoucsId = 'infoCustInput_search_SAL1030';
    const empInfoHandleFoucsId = 'infoEmpInput_search_SAL1030';
	
    // Info 폼 코드 검색 필드 설정
    const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
        {
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find((value) => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: SAL1030_R01Filter.customCd || '',
				customNm: SAL1030_R01Filter.customNm || '',
			}),
        },
        {
			fieldName: 'empNo',
			category: '담당자',
			focusId: empInfoHandleFoucsId,
			responseMapping: {
				empNo: 'empNo',
				empNm: 'empNm',
			},
			searchFunction: async (searchText: string) => {
				const employeeResponse = await getEmployeeList(searchText);
				return employeeResponse.data.data.find((value) => value.empNo === searchText);
			},
			extraFilter: () => ({
				empNo: SAL1030_R01Filter.empNo || '',
				empNm: SAL1030_R01Filter.empNm || '',
			}),
        },
    ];

    // Info 폼 이벤트 훅 사용
    const { getFieldHandlers } = useInfoFormEvents({
        editData: SAL1030_R01Filter,
        setEditData: setSAL1030_R01Filter,
        defaultData: defaultSAL1030_R01Filter,
        infoFieldConfigs,
        setCodeSearchModalProps,
        formName: 'SAL1030_R01_search'
    });

    // 컴포넌트 마운트 시 기본값 설정
    // useEffect(() => {
    //     // 기본 필터가 설정되지 않은 경우에만 초기화
    //     if (!SAL1030_R01Filter.dateRange?.from || !SAL1030_R01Filter.dateRange?.to) {
    //     setSAL1030_R01Filter({
    //         ...defaultSAL1030_R01Filter
    //     });
    //     }
    // }, []);

    return (
        <>
        <SearchSectionForm>
            {/* 사업장 드롭다운 */}
            <SearchDropDownForm<CompanyDto>
				label="사업장"
				value={SAL1030_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={v => setSAL1030_R01Filter({ compCd: v === 'all' ? '' : v })}
                wrapperOption={{
                    wrapperStyle: "w-[200px] min-w-[200px] mr-[10px]",
                    titleStyle: "w-[45px] min-w-[45px] text-left",
                    selectStyle: "w-[100px] min-w-[100px]",
                }}
            />
            
            {/* 수주기간 날짜 범위 */}
            <SearchDateRangeForm
				label="수주기간"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={SAL1030_R01Filter.dateRange}
				setDateRange={(dateRange) => setSAL1030_R01Filter({ dateRange: dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
                wrapperOption={{
                    wrapperStyle: "w-[250px] min-w-[250px] mr-[10px]",
                    titleStyle: searchLabelStyle,
                    dateRangeStyle: searchDateRangeFormString,
                }}
            />
            
            {/* 거래처 입력 및 검색 영역 */}
            <SearchCodeModalForm
				label="거래처"
				value={SAL1030_R01Filter.customCd}
				valueLabel={SAL1030_R01Filter.customNm}
				handleFoucsId={custInfoHandleFoucsId}
				onChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
            />
            
            {/* 담당자 입력 및 검색 영역 */}
            <SearchCodeModalForm
				label="담당자"
				value={SAL1030_R01Filter.empNo}
				valueLabel={SAL1030_R01Filter.empNm}
				handleFoucsId={empInfoHandleFoucsId}
				onChange={getFieldHandlers('empNo').onChange}
				onDoubleClick={getFieldHandlers('empNo').onDoubleClick}
				onKeyDown={getFieldHandlers('empNo').onEnterKeyDown}
            />
        </SearchSectionForm>
        </>
    );
    };

    export default SearchSection_SAL1030_R01;
